"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_1 = require("apollo-link");
const R = __importStar(require("ramda"));
const utils_1 = require("./utils");
const mutations_1 = require("./graphql/mutations");
/**
 * SignUp Link sends userSignUp mutation on server if user isn't registered
 * @param {SignUpLinkParameters} options - The link\'s options.
 * @param {Function} options.getAuthState - Function which called to get user\'s email and auth token.
 * @param {String} options.authProfileId - Auth Profile Id copied from 8base authentication page.
 */
class SignUpLink extends apollo_link_1.ApolloLink {
    constructor({ getAuthState, authProfileId }) {
        super();
        this.getAuthState = getAuthState;
        this.authProfileId = authProfileId;
        this.signUpPromise = null;
        this.fetching = false;
    }
    request(operation, forward) {
        return new apollo_link_1.Observable(observer => {
            let subscription = null;
            const handleUserNotExistError = () => {
                this.sendSignUp(operation, forward)
                    .then(() => {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                    subscription = forward(operation).subscribe(subscriber);
                })
                    .catch(error => {
                    observer.error(error);
                });
            };
            const subscriber = {
                complete: () => {
                    if (!this.fetching) {
                        observer.complete();
                    }
                },
                error: (error) => {
                    const batchedErrors = R.pathOr([error], ['response', 'parsed', 'errors'], error);
                    if (utils_1.hasUserNotFoundError(batchedErrors)) {
                        handleUserNotExistError();
                    }
                    else {
                        observer.error(error);
                    }
                },
                next: (data) => {
                    const errors = data.errors || [];
                    if (utils_1.hasUserNotFoundError(errors)) {
                        this.fetching = true;
                        handleUserNotExistError();
                    }
                    else {
                        observer.next(data);
                    }
                },
            };
            subscription = forward(operation).subscribe(subscriber);
        });
    }
    sendSignUp(operation, forward) {
        return __awaiter(this, void 0, void 0, function* () {
            const { email } = this.getAuthState({ operation });
            if (this.signUpPromise === null) {
                this.signUpPromise = new Promise((resolve, reject) => {
                    const signUpOperation = apollo_link_1.createOperation(operation.getContext(), {
                        query: mutations_1.SIGNUP_MUTATION,
                        variables: {
                            authProfileId: this.authProfileId,
                            user: {
                                email,
                            },
                        },
                    });
                    forward(signUpOperation).subscribe({
                        complete: () => {
                            this.signUpPromise = null;
                            this.fetching = false;
                        },
                        error: reject,
                        next: data => {
                            if (R.path(['data', 'userSignUp', 'id'], data)) {
                                resolve();
                            }
                            else {
                                reject(data);
                            }
                        },
                    });
                });
            }
            return this.signUpPromise;
        });
    }
}
exports.SignUpLink = SignUpLink;
//# sourceMappingURL=SignUpLink.js.map